import React from 'react';
import { Box } from '@mui/material';

export default function ResizeHandle({ onMouseDown, isResizing }) {
  return (
    <Box
      onMouseDown={onMouseDown}
      sx={{
        position: 'absolute',
        right: 0,
        top: 0,
        bottom: 0,
        width: '10px',
        cursor: 'col-resize',
        userSelect: 'none',
        backgroundColor: isResizing ? '#1A2B4A' : 'transparent',
        transition: 'background-color 0.2s',
        '&:hover': { backgroundColor: '#1A2B4A', opacity: 0.4 },
        '&::after': {
          content: '""',
          position: 'absolute',
          right: '4px',
          top: '50%',
          transform: 'translateY(-50%)',
          width: '2px',
          height: '24px',
          backgroundColor: isResizing ? '#1A2B4A' : '#aaa',
          borderRadius: '1px',
          transition: 'background-color 0.2s'
        },
        zIndex: 10
      }}
    />
  );
}
